import { useState, useEffect } from 'react';
import "./Qualification.css";

const Qualification = () => {
  const [activeTab, setActiveTab] = useState('education');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const educationData = [
    {
      id: 1,
      title: "Higher Technical Certificate",
      institution: "IMSET SOUSSE | Université Centrale",
      period: "2023-2025",
      type: "Higher Education",
      icon: "bx bxs-graduation",
      description: "Advanced technical education in web development and software engineering"
    },
    {
      id: 2,
      title: "Bachelor's Degree in Economics and Management",
      institution: "Teboulba Technical High School",
      period: "2021",
      type: "Secondary Education",
      icon: "bx bxs-school",
      description: "Foundation in economics, management, and analytical thinking"
    }
  ];

  const certificationData = [
    {
      id: 1,
      title: "Python Essentials I",
      institution: "Cisco Networking Academy",
      period: "2024",
      type: "Certification",
      icon: "bx bxs-certification",
      description: "Comprehensive Python programming fundamentals and best practices"
    }
  ];

  const experienceData = [
    {
      id: 1,
      title: "Final Year Project Intern",
      institution: "Vitalait, Mahdia",
      period: "2 months",
      type: "Internship",
      icon: "bx bxs-briefcase",
      description: "Designed and developed an AI-powered Helpdesk Agent with MCP server integrated with OpenWebUI and local LLM on Ollama. Built scalable microservices architecture.",
      keywords: "Python, FastMCP, MCP Server, OpenWebUI, Ollama, Local LLM, Agile, Microservices"
    },
    {
      id: 2,
      title: "Intern",
      institution: "SWConsulting, Monastir",
      period: "1 month",
      type: "Internship",
      icon: "bx bxs-briefcase",
      description: "Developed MailCraftr: a secure email-template platform. Contributed to frontend and backend development, implementing APIs and UI components.",
      keywords: "NestJS, Prisma, SQLite, Next.js, Tailwind, JWT, RBAC, Webhooks, Nodemailer"
    },
    {
      id: 3,
      title: "Intern",
      institution: "LEONI, Sousse",
      period: "1 month",
      type: "Internship",
      icon: "bx bxs-briefcase",
      description: "Developed a stock management platform to streamline inventory tracking and optimize warehouse operations.",
      keywords: "Python, Django, PostgreSQL, CRUD Operations"
    }
  ];

  const renderTimelineItem = (item, index, isLast) => (
    <div key={item.id} className={`timeline__item ${index % 2 === 0 ? 'left' : 'right'}`}>
      <div className="timeline__content">
        <div className="timeline__card">
          <div className="timeline__header">
            <div className="timeline__icon-wrapper">
              <i className={item.icon}></i>
            </div>
            <div className="timeline__badge">{item.type}</div>
          </div>
          <h3 className="timeline__title">{item.title}</h3>
          <h4 className="timeline__institution">{item.institution}</h4>
          <p className="timeline__description">{item.description}</p>
          {item.keywords && (
            <div className="timeline__keywords">
              {item.keywords.split(', ').map((keyword, idx) => (
                <span key={idx} className="keyword-tag">{keyword}</span>
              ))}
            </div>
          )}
          <div className="timeline__period">
            <i className="bx bx-calendar"></i>
            <span>{item.period}</span>
          </div>
        </div>
      </div>
      {!isLast && <div className="timeline__connector"></div>}
    </div>
  );

  return (
    <section id='qualification' className="qualification section">
      <div className="qualification__header">
        <h2 className="section__title">Qualification</h2>
        <p className="section__subtitle">My Educational & Professional Journey</p>
        <div className="qualification__divider"></div>
      </div>
      
      <div className="qualification__container container">
        <div className="qualification__tabs">
          <button
            className={`qualification__tab ${activeTab === 'education' ? 'active' : ''}`}
            onClick={() => setActiveTab('education')}
          >
            <i className="bx bxs-graduation"></i>
            <span>Education</span>
          </button>
          <button
            className={`qualification__tab ${activeTab === 'certifications' ? 'active' : ''}`}
            onClick={() => setActiveTab('certifications')}
          >
            <i className="bx bxs-certification"></i>
            <span>Certifications</span>
          </button>
          <button
            className={`qualification__tab ${activeTab === 'experience' ? 'active' : ''}`}
            onClick={() => setActiveTab('experience')}
          >
            <i className="bx bxs-briefcase"></i>
            <span>Experience</span>
          </button>
        </div>

        <div className={`qualification__content ${isVisible ? 'visible' : ''}`}>
          <div className="timeline">
            {(activeTab === 'education' ? educationData : activeTab === 'certifications' ? certificationData : experienceData).map((item, index, array) => 
              renderTimelineItem(item, index, index === array.length - 1)
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
